export default {
  env: 'development', // /sb/ what is this used for?
  apiUrl: 'https://api.staging.referoo.co',
  sentryEnv: 'staging', // /jv/ can't use above 'env' because it looks like its used as part of build process however I could not find how or where it is used.
};
